import { useEffect } from "react"

export const useClickOutside = (onOutsideClick: () => void, ref: React.RefObject<HTMLElement>): void => {
  useEffect(() => {
    const handleClickOutside = (e: MouseEvent) => {
      const selection = window.getSelection()
      if (
        ref.current &&
        !ref.current.contains(e.target as Node) &&
        (!selection || selection.toString().trim() === "")
      ) {
        onOutsideClick()
      }
    }

    document.addEventListener("click", handleClickOutside, true)

    return () => {
      document.removeEventListener("click", handleClickOutside, true)
    }
  }, [ref, onOutsideClick])
}

export default useClickOutside
